<template>
    <div>
        <v-footer :fixed="true" app>
            <span>Learn</span>
            <span class="font-weight-light">App &copy;</span>
        </v-footer>
    </div>
</template>

<script>
    export default {
        name: "AppFooter"
    }
</script>

<style scoped>

</style>
